export default "__VITE_ASSET__4670785e__"